import { axiosInstance, ENDPOINT } from 'common/constants';
import { handleResponse } from 'common/helpers';

export const fmeaTemplatesService = {
  listTemplates,
  getTemplate,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  promoteTemplate,
  listComponentTypes,
};

function listTemplates(scope) {
  return handleResponse(axiosInstance.get(ENDPOINT.GET_FMEA_TEMPLATES, { params: { scope } }));
}

function getTemplate(templateId) {
  return handleResponse(axiosInstance.get(ENDPOINT.GET_FMEA_TEMPLATE(templateId)));
}

function createTemplate(body) {
  return handleResponse(axiosInstance.post(ENDPOINT.CREATE_FMEA_TEMPLATE, body));
}

function updateTemplate(templateId, body) {
  return handleResponse(axiosInstance.put(ENDPOINT.UPDATE_FMEA_TEMPLATE(templateId), body));
}

function deleteTemplate(templateId) {
  return handleResponse(axiosInstance.delete(ENDPOINT.DELETE_FMEA_TEMPLATE(templateId)));
}

function promoteTemplate(templateId, body) {
  return handleResponse(axiosInstance.post(ENDPOINT.PROMOTE_FMEA_TEMPLATE(templateId), body));
}

function listComponentTypes() {
  return handleResponse(axiosInstance.get(ENDPOINT.GET_FMEA_COMPONENT_TYPES));
}
